import React, { useEffect, useState } from "react";
import api from "../../api";
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Filler,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import ChartInfoPopup from "./ChartInfoPopup";

ChartJS.register(
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Filler,
  Tooltip,
  Legend
);

const HourlyChatTrafficChart = () => {
  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [],
  });
  const [themeColors, setThemeColors] = useState({
    text: "#000",
    grid: "#e0e0e0",
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token =
          localStorage.getItem("access_token") ||
          sessionStorage.getItem("access_token");

        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };

        const baseUrl = process.env.REACT_APP_API_URL;
        const response = await api.get(
          `${baseUrl}/chat/hourly-traffic`,
          config
        );

        const traffic = response.data.hourlyTraffic || [];

        const labels = traffic.map((item) => item.hour); // ['23:00', '0:00', ...]
        const data = traffic.map((item) => item.count); // [0, 0, 0, ...]

        setChartData({
          labels,
          datasets: [
            {
              label: "Users",
              data,
              fill: true,
              backgroundColor: "rgba(0, 0, 0, 0.05)",
              borderColor: "#3E3E3E",
              pointBackgroundColor: "#6B6B6B",
              pointRadius: 4,
              pointHoverRadius: 5,
              tension: 0.2,
            },
          ],
        });
      } catch (error) {
        console.error("❌ Failed to fetch hourly chat traffic:", error);
      }
    };

    fetchData();
  }, []);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: (context) => `${context.raw} users`,
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: { stepSize: 200 },
        grid: { display: false },
        title: {
          display: true,
          text: "Number of Conversations",
          color: themeColors.text,
          font: { size: 13, weight: "bold" },
        },
      },
      x: {
        grid: { display: false },
        title: {
          display: true,
          text: "Hours",
          color: themeColors.text,
          font: { size: 13, weight: "bold" },
          padding: { top: 10 },
        },
      },
    },
  };

  return (
    <div className="chart-card p-3 shadow-sm rounded mb-4 profile-i">
      <div className="d-flex align-items-center gap-2 mb-3">
        <h5 className="fw-semibold m-0">
          <span className="border-start border-4 border-dark ps-2">
            Hourly Conversations Traffic
          </span>
        </h5>

        {/* NEW FIX: icon wrapper prevents shifting */}
        <div style={{ position: "relative", display: "inline-block" }}>
          <ChartInfoPopup text="This chart shows how many conversations were handled by the chatbot during each hour over the last 12 hours. The Y-axis represents the number of conversations and the X-axis showing each hour in chronological order. This helps you quickly identify peak activity periods, spikes, or drops in hourly chatbot engagement." />
        </div>
      </div>
      <div style={{ height: "300px", width: "100%" }}>
        <Line data={chartData} options={options} />
      </div>
    </div>
  );
};

export default HourlyChatTrafficChart;
